// extracted by mini-css-extract-plugin
export default {"chat_body":"ChatFrame_chat_body__dTSXY","voice_only":"ChatFrame_voice_only__rtgev"};